module.exports = __webpack_public_path__ + "static/media/dropdown.1f5cdad6.svg";